// extracted by mini-css-extract-plugin
export default {"close":"Modal_close__F+oll"};